const degreesPerRadian = 180 / Math.PI;
const radiansPerDegree = Math.PI / 180;

/**
 * Converts an angle in radians to its equivalent in degrees.
 *
 * @param {Number} angleInRadians The angle in radians to convert.
 *
 * @return {Number} The equivalent angle in degrees.
 */
const radiansToDegrees = (angleInRadians) => angleInRadians * degreesPerRadian;

/**
 * Converts an angle in degrees to its equivalent in radians.
 *
 * @param {Number} angleInDegrees The angle in degrees to convert.
 *
 * @return {Number} The equivalent angle in radians.
 */
const degreesToRadians = (angleInDegrees) => angleInDegrees * radiansPerDegree;

module.exports = {
    radiansToDegrees,
    degreesToRadians
};
